import { IInitalState } from "./interface";
import * as TYPES from "./type";

const initialState: IInitalState = {
  change: null,
  loading: true,
};

export const changeDeviceReducer = (
  state: IInitalState,
  { type, payload }: any
) => {
  state = state || initialState;
  switch (type) {
    case TYPES.INVALID_PAYLOAD:
    case TYPES.CHANGE_EVICE_CURRENT_REQ:
      return {
        state,
      };
    case TYPES.CHANGE_DEVICE_CURRENT_SUCCESS:
      return { ...state, loading: false, change: payload };
    case TYPES.CHAGE_DEVICE_EDIT:
      return { ...state, loading: false, change: payload };
      case TYPES.CHANGE_DEVICE_DELETE:
        return { ...state, loading: false, change: payload };
    case TYPES.CHANGE_DEVICE_CURRENT_FAIL:
      return {
        ...state,
        loading: false,
        change: null,
      };
    default:
      return state;
  }
};
